import React from 'react'
import { motion } from "framer-motion";
import { useInView } from "react-intersection-observer";

const slideIn = {
  visible: { opacity: 1, translateX: 0 },
  hidden: { opacity: 0, translateX: -200 },
};

const HeroContent = () => {
  const [ref, inView] = useInView({
		triggerOnce: true,
		threshold: 0.3
	  });
	
  return (

    /* -------------------------------------------------------------------------- */
    /*                              Content Container                             */
    /* -------------------------------------------------------------------------- */
    <motion.div
      ref={ref}
      initial="hidden"
      animate={inView ? "visible" : "hidden"}
      variants={slideIn}
      transition={{ duration: 0.8, ease: "easeIn" }}
      className="z-30 max-w-[1200px]  pb-2 px-6 flex-col  items-center font-popp bottom-64 sm:bottom-60"
    >

        {/* ------------------------------ Main Heading ------------------------------ */}
        <h1 className="text-3xl tablet:text-4xl md:text-5xl text-center text-white pb-4 md:pb-6" >
            Data Science Club
        </h1>

        {/* -------------------------------- Tag Line ------------------------------- */}
        <p className="text-center text-lg  tablet:text-xl md:text-2xl text-secondary pb-4 md:pb-6" >
            Where data meets insight, and innovation takes flight.
        </p>

        {/* ----------------------------- University Name ---------------------------- */}
        <h2 className="text-center text-2xl tablet:3xl md:text-4xl text-white ">
            VIT Chennai
        </h2>
        
    </motion.div>
  )
}

export default HeroContent